import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export enum DialogType {
  Jira = 'jira',
  Confluence = 'confluence',
  Import = 'import',
  Confirm = 'confirm',
  /**
   * The Duplicate dialog is only shown in Confluence and NOT in embeds
   */
  // Duplicate = 'duplicate',
  Export = 'export',
}

/**
 * @see {@link ShowDialogCommand}
 */
export interface ShowDialogCommandProperties extends CommandProperties {
  type: DialogType;
}

/**
 * Command to show database dialogs in the native embed experience.
 *
 * This command displays dialogs for Jira integration, Confluence connections,
 * CSV import, and confirmation dialogs, ensuring they appear in the host
 * application's UI context rather than within the database iframe.
 */
export const ShowDialogCommand = createCommand<ShowDialogCommandProperties, void>(
  'show-dialog-command'
);
